import React from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles, Grid, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { URLS } from 'app/config/urls';

import styles from './styles';
const useStyles = makeStyles(styles);

function BreadCrumb(props) {
  const classes = useStyles();
  const { intl, onBack, breadCrumb, rightInfo } = props;
  const history = useHistory();

  const renderElements = () => {
    let elements = [];
    if (breadCrumb) {
      elements = breadCrumb.map((elem, index) => {
        return (
          <li key={index} className={classes.title}>
            {elem.path && elem.path !== '' ? (
              <Button
                className={classes.btnBack}
                color="primary"
                onClick={() => history.push(elem.path)}
              >
                {elem.title}
              </Button>
            ) : (
              <h1>{elem.title}</h1>
            )}
          </li>
        );
      });
    }
    elements.unshift(
      <li key="first">
        <Button
          className={classes.btnBack}
          color="primary"
          onClick={() => !!onBack ? onBack() : history.push(URLS.START)}
        >
          {intl.formatMessage({ id: 'LABELS.COMMONS.BACK' })}
        </Button>
      </li>
    );
    return elements;
  };

  return (
    <Grid container spacing={3} className={classes.header}>
      <Grid item xs={12} sm={8}>
        <ul className={classes.linksBreadcrumb}>{renderElements()}</ul>
      </Grid>
      {rightInfo && (
        <Grid item xs={12} sm={4} className={classes.rightInfo}>
          {rightInfo}
        </Grid>
      )}
    </Grid>
  );
}

export default injectIntl(BreadCrumb);
